import SmartTooltip from '../../Report/SmartTooltip';

// BlockReason (Virus Name) Just for VA
export const BlockReason = ({ logItem }: { logItem: any }) => {
  const { ddaaasRiskLevel, blockReason } = logItem;

  //didn't show the blockReason for no risk or unknown risk
  if (
    ddaaasRiskLevel &&
    !['Low Risk', 'Medium Risk', 'High Risk'].includes(ddaaasRiskLevel)
  ) {
    return <></>;
  }

  return (
    <SmartTooltip>
      {Array.isArray(blockReason) ? blockReason.join(';') : blockReason}
    </SmartTooltip>
  );
};
